export const ACTION_TYPE = 'actionType';
export const TEMPLATE = 'template';
export const VARIABLE_CONTEXT = 'variableContext';
export const LANGUAGE_TAG = 'languageTag';